<ngx-loading-bar [includeSpinner]="false" height="4px" color="#FF0000"></ngx-loading-bar>
<div class="pages">
  <div data-page="fahrzeuge" class="page no-toolbar no-navbar">
    <div class="page-content">

      <div class="navbarpages">
        <div class="navbar_left">
          <a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"/></a>
        </div>
        <div class="navbar_center"><h2>{{ this.Ueberschrift }}</h2></div>
        <div class="navbar_right">
          <a [routerLink]="['/user']" data-panel="right" class="open-panel"><img
          src="./assets/images/icons/blue/user.png" alt="" title=""/></a>
        </div>
      </div>
    </div>
    <div class="bottombarpages">
      <div class="gallery_switch" style="justify-content: center;align-items: center; display: flex;">
        @if (this.anzeigeBereich0) {
          <div style="float: left;">
            <img id="btn_0" (click)="select_bereich(0);" height="35px" src="./assets/images/amt_active.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich0 > 0) {
              <div class="notifynumber">{{ this.zahlBereich0 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich1) {
          <div  style="float: left;">
            <img id="btn_1" (click)="select_bereich(1);" height="35px" src="./assets/images/bereich_1.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich1 > 0) {
              <div class="notifynumber">{{ this.zahlBereich1 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich2) {
          <div  style="float: left;">
            <img id="btn_2" (click)="select_bereich(2);" height="35px" src="./assets/images/bereich_2.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich2 > 0) {
              <div class="notifynumber">{{ this.zahlBereich2 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich3) {
          <div  style="float: left;">
            <img id="btn_3" (click)="select_bereich(3);" height="35px" src="./assets/images/bereich_3.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich3 > 0) {
              <div class="notifynumber">{{ this.zahlBereich3 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich4) {
          <div  style="float: left;">
            <img id="btn_4" (click)="select_bereich(4);" height="35px" src="./assets/images/bereich_4.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich4 > 0) {
              <div class="notifynumber">{{ this.zahlBereich4 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich5) {
          <div  style="float: left;">
            <img id="btn_5" (click)="select_bereich(5);" height="35px" src="./assets/images/bereich_5.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich5 > 0) {
              <div class="notifynumber">{{ this.zahlBereich5 }}</div>
            }
          </div>
        }
        @if (this.anzeigeBereich6) {
          <div  style="float: left;">
            <img id="btn_6" (click)="select_bereich(6);" height="35px" src="./assets/images/bereich_son.png">&nbsp;&nbsp;&nbsp;
            @if (this.zahlBereich6 > 0) {
              <div class="notifynumber">{{ this.zahlBereich6 }}</div>
            }
          </div>
        }

      </div>
    </div>
    <div #hash_fzgStatus id="pages_maincontent">
      <div class="tabs-animated-wrap photos_tabs">
        <div class="tabs">
          @if (aktiver_bereich == 0) {
            <div id="tabamt" class="tab active">
              <ul>
                @for (Fzg of Fahrzeuge; track Fzg) {
                  <span>
                    @if (Fzg.bereich == '0') {
                      <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                        <table class="fzg_table">
                          <tr>
                            <td class="td_status" rowspan="2">
                              <span class="day">{{ Fzg.status}}</span>
                            </td>
                            <td>
                              <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                              -> {{ Fzg.bezeichnung}}</h2></div>
                            </td>
                          </tr>
                          <tr>
                            <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                          </tr>
                        </table>
                      </li>
                    }
                  </span>
                  }<br><br>
                </ul>
              </div>
            }

            @if (aktiver_bereich == 1) {
              <div id="tab1" class="tab">
                <ul>
                  @for (Fzg of Fahrzeuge; track Fzg) {
                    <span>
                      @if (Fzg.bereich == '1') {
                        <li (dblclick)="changestatus(Fzg.issi);"  [ngClass]="'status'+Fzg.status">
                          <table class="fzg_table">
                            <tr>
                              <td class="td_status" rowspan="2">
                                <span class="day">{{ Fzg.status}}</span>
                              </td>
                              <td>
                                <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                -> {{ Fzg.bezeichnung}}</h2></div>
                              </td>
                            </tr>
                            <tr>
                              <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                            </tr>
                          </table>
                        </li>
                      }
                    </span>
                    }<br><br>
                  </ul>
                </div>
              }

              @if (aktiver_bereich == 2) {
                <div id="tab2" class="tab">
                  <ul>
                    @for (Fzg of Fahrzeuge; track Fzg) {
                      <span>
                        @if (Fzg.bereich == '2') {
                          <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                            <table class="fzg_table">
                              <tr>
                                <td class="td_status" rowspan="2">
                                  <span class="day">{{ Fzg.status}}</span>
                                </td>
                                <td>
                                  <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                  -> {{ Fzg.bezeichnung}}</h2></div>
                                </td>
                              </tr>
                              <tr>
                                <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                              </tr>
                            </table>
                          </li>
                        }
                      </span>
                      }<br><br>
                    </ul>
                  </div>
                }

                @if (aktiver_bereich == 3) {
                  <div id="tab3" class="tab">
                    <ul>
                      @for (Fzg of Fahrzeuge; track Fzg) {
                        <span>
                          @if (Fzg.bereich == '3') {
                            <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                              <table class="fzg_table">
                                <tr>
                                  <td class="td_status" rowspan="2">
                                    <span class="day">{{ Fzg.status}}</span>
                                  </td>
                                  <td>
                                    <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                    -> {{ Fzg.bezeichnung}}</h2></div>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                </tr>
                              </table>
                            </li>
                          }
                        </span>
                        }<br><br>
                      </ul>
                    </div>
                  }


                  @if (aktiver_bereich == 4) {
                    <div id="tab4" class="tab">
                      <ul>
                        @for (Fzg of Fahrzeuge; track Fzg) {
                          <span>
                            @if (Fzg.bereich == '4') {
                              <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                <table class="fzg_table">
                                  <tr>
                                    <td class="td_status" rowspan="2">
                                      <span class="day">{{ Fzg.status}}</span>
                                    </td>
                                    <td>
                                      <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                      -> {{ Fzg.bezeichnung}}</h2></div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                  </tr>
                                </table>
                              </li>
                            }
                          </span>
                          }<br><br>
                        </ul>
                      </div>
                    }

                    @if (aktiver_bereich == 5) {
                      <div id="tab5" class="tab">
                        <ul>
                          @for (Fzg of Fahrzeuge; track Fzg) {
                            <span>
                              @if (Fzg.bereich == '5') {
                                <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                  <table class="fzg_table">
                                    <tr>
                                      <td class="td_status" rowspan="2">
                                        <span class="day">{{ Fzg.status}}</span>
                                      </td>
                                      <td>
                                        <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                        -> {{ Fzg.bezeichnung}}</h2></div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                    </tr>
                                  </table>
                                </li>
                              }
                            </span>
                          }
                          <br><br>
                        </ul>
                      </div>
                    }
                    @if (aktiver_bereich == 6) {
                      <div id="tab6" class="tab">
                        <ul>
                          @for (Fzg of Fahrzeuge; track Fzg) {
                            <span>
                              @if (Fzg.bereich == '20') {
                                <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                  <table class="fzg_table">
                                    <tr>
                                      <td class="td_status" rowspan="2">
                                        <span class="day">{{ Fzg.status}}</span>
                                      </td>
                                      <td>
                                        <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                        -> {{ Fzg.bezeichnung}}</h2></div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                    </tr>
                                  </table>
                                </li>
                              }
                            </span>
                          }
                          @for (Fzg of Fahrzeuge; track Fzg) {
                            <span>
                              @if (Fzg.bereich == '103') {
                                <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                  <table class="fzg_table">
                                    <tr>
                                      <td class="td_status" rowspan="2">
                                        <span class="day">{{ Fzg.status}}</span>
                                      </td>
                                      <td>
                                        <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                        -> {{ Fzg.bezeichnung}}</h2></div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                    </tr>
                                  </table>
                                </li>
                              }
                            </span>
                          }
                          @for (Fzg of Fahrzeuge; track Fzg) {
                            <span>
                              @if (Fzg.bereich == '57') {
                                <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                  <table class="fzg_table">
                                    <tr>
                                      <td class="td_status" rowspan="2">
                                        <span class="day">{{ Fzg.status}}</span>
                                      </td>
                                      <td>
                                        <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                        -> {{ Fzg.bezeichnung}}</h2></div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                    </tr>
                                  </table>
                                </li>
                              }
                            </span>
                            }@for (Fzg of Fahrzeuge; track Fzg) {
                            <span>
                              @if (Fzg.bereich == '980') {
                                <li (dblclick)="changestatus(Fzg.issi);" [ngClass]="'status'+Fzg.status">
                                  <table class="fzg_table">
                                    <tr>
                                      <td class="td_status" rowspan="2">
                                        <span class="day">{{ Fzg.status}}</span>
                                      </td>
                                      <td>
                                        <div class="fahrzeug_title"><h2>{{ Fzg.ort}}
                                        -> {{ Fzg.bezeichnung}}</h2></div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="td_datum">Stand: {{ Fzg.timestamp}}</td>
                                    </tr>
                                  </table>
                                </li>
                              }
                            </span>
                          }
                          <br><br>
                        </ul>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
